<template>
  <v-dialog v-model="dialogStoreManager" persistent max-width="70%">
    <v-card>
      <v-card-title>
        <span class="title">Nhập kho ngày {{currentTime | display_date('DD-MM-YYYY')}}</span>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg5 md5 sm5>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0 ma-0>
                <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  label="Mã kiện"
                  ref="trancode"
                  v-model="currentItem.TransactionCode"
                  class="input-group--focused"
                  :rules="requireRules"
                  @input="codeChanged"
                  @keyup.enter="manualChanged"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeShip"
                  :decimal="0"
                  label="Phí vận chuyển"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex> -->
              <!-- <v-flex lg12 md12 sm12 pa-0>
                <v-select v-model="currentItem.ShippingMethod" :items="shipping_methods" item-text="name" item-value="value" label="Hình thức vận chuyển" class="input-group--focused"></v-select>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-select v-model="currentItem.ProductType" :items="product_types" item-text="name" item-value="value" label="Loại hàng" class="input-group--focused"></v-select>
              </v-flex> -->
              <v-flex lg12 md12 sm12 pa-0>
                <v-select v-model="currentItem.Status" :items="package_status" item-text="name" item-value="value" label="Trạng thái" class="input-group--focused"></v-select>
              </v-flex>
              <v-flex lg12 md12 sm12 offset-md-10 pa-0>
                <v-btn @click="manualChanged" :disabled="useBarcodeReader">Nhập</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg7 md7 sm7>
            <v-layout pl-4 pr-2 pt-12>
              <v-flex lg12 md12 sm12>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :options.sync="pagination"
                  :server-items-length="total_rows"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr>
                      <td>{{ item.ID }}</td>
                      <td>{{ item.TransactionCode }}</td>
                      <!-- <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.FeeShip"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.FeeShip | currency}}</div>
                          <template v-slot:input>
                            <v-text-field
                              v-model="item.FeeShip"
                              type="number"
                              label="Phí ship"
                              single-line
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td> -->
                      <td class="text-center">
                        <v-icon small @click="deleteItem(item.ID)">delete</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closePopup">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment";
import { getCurrentTime } from "@/commons/utils";
export default {
  name: "store-popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 8;
    return {
      useBarcodeReader: true,
      currentItem: {
        TransactionCode: "",
        Status: 0
      },
      filterData: {
        column: "CreatedDate",
        value: getCurrentTime(),
        condition: "d_equal"
      },
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Mã kiện",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        // {
        //   text: "Phí ship",
        //   value: "FeeShip",
        //   align: "end",
        //   filterable: true,
        //   dataType: dataType["Number"]
        // },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [8] },
      currentTime: getCurrentTime(),
      shipping_methods: configs.SHIPPING_METHOD,
      product_types: configs.PRODUCT_TYPE,
      package_status: configs.PACKAGE_STATUS,
    };
  },
  props: ["dialogStoreManager"],
  watch: {
    dialogStoreManager() {
      if (this.dialogStoreManager) {
        this.$nextTick(() => this.$refs.trancode.focus());
        this.getListData();
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.storeManager.listOfDay.data,
      total_rows: state => state.storeManager.listOfDay.total,
      loading: state => state.storeManager.loading
    }),
    userRole() {
      return this.$store.state.authentication.user.roleid;
    }
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    deleteItem(id) {
      this.$emit("deleteItem", id);
    },
    saveItem(item) {
        this.$store.dispatch("storeManager/setDetail", {
          data: item,
          id: item.ID
        });
    },
    manualChanged() {
      if (this.currentItem.TransactionCode !== "" && !this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentItem.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      function() {
        this.currentItem.TransactionCode = this.currentItem.TransactionCode.toLowerCase().trim();
        let postData = {...this.currentItem}
        if(this.userRole == 0) {
          postData.UID = this.$store.state.authentication.user.userid;
        }
        
        this.$store.dispatch("storeManager/setDetail", {
          data: postData
        });
        this.currentItem.TransactionCode = '';
        this.$nextTick(() => this.$refs.trancode.focus());
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    getListData() {
      var param = {
        pagination: this.pagination,
        filter: [this.filterData],
        quickFilter: []
      };
      this.$store.dispatch("storeManager/getListOfDay", param);
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.getListData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getListData);
  }
};
</script>
